<template>
  <div>
    <form action="">
      <ul>
        <li
          class="mb-3"
          v-for="item in formItems" :key="item.name">
          <label
            class="fs-sm fw-bold fc-gray"
            for="">
            {{ item.label }}
            <span
              :class="s.required"
              v-if="item.required"> ※{{ item.requiredLabel || '必須項目'}}</span>
          </label>

          <!-- formはtypeで出しわけ -->

          <!-- text -->
          <input
            v-if="item.type === 'text' || item.type === 'email'"
            class="form-control form-control-sm"
            type="item.type"
            v-model="item.value">
          <span v-if="item.value && item.type === 'email' && isValid(item.type, item.value)" :class="s.valid">
            ＊メールアドレスの形式が正しくありません
          </span>

          <div v-if="item.type === 'email' && item.confirm" class="mt-3">
            <label
              class="fs-sm fw-bold fc-gray"
              for="">メールアドレス(確認用)
              <span :class="s.required"> ※必須項目</span>
            </label>
            <input
              class="form-control form-control-sm"
              type="email"
              v-model="confirmEmail">

            <span
              v-if="item.value !== confirmEmail"
              :class="s.valid">メールアドレスが一致しません</span>
          </div>

          <!-- number -->
          <div v-if="item.type === 'number'" class="d-flex">
            <input
              class="form-control form-control-sm"
              type="number"
              v-model="item.value">
            <span
              v-if="item.suffix"
              :class="s.suffix"
              class="ms-3 d-flex align-items-center">{{ item.suffix }}</span>
          </div>

          <!-- textarea -->
          <textarea
            v-if="item.type === 'textarea'"
            class="form-control form-control-sm"
            :rows="item.size === 'half' ? 5 : 10"
            v-model="item.value" />

          <!-- select -->
          <div v-if="item.type === 'select'" :class="s.select_wrap">
            <select
              class="form-control form-control-sm"
              :name="item.name"
              :id="item.name"
              :disabled="!item.options.length"
              v-model="item.value">
              <option :value="0">選択してください</option>
              <option
                v-for="opt in item.options"
                :key="opt.id || opt.value"
                :value="opt.id || opt.value"
                :selected="opt.id ? opt.id === item.value : opt.value === item.value">{{ opt.label || opt.name }}</option>
            </select>
          </div>

          <!-- checkbox -->
          <div
            v-if="item.type === 'checkbox'"
            class="d-flex align-items-center">
            <input
              class="me-2"
              style="display: none;"
              type="checkbox"
              :id="item.name"
              :name="item.name"
              :true-value="1"
              :false-value="0"
              :checked="item.value === 1"
              :disabled="item.disabled"
              v-model="item.value">
            <label
              :class="[s.checkbox, item.value === 1 ? s.checked : '']"
              class="fs-sm"
              :for="item.name"
              >{{ item.message }}</label>
          </div>

          <!-- date -->
          <div v-if="item.type === 'date'" class="d-flex">
            <DateSelector
              :showAge="item.showAge"
              @input="updateValue(item.name, $event)"
            />
            <img v-if="item.preview" :src="item.preview" :class="s.image_preview" />
          </div>

          <!-- image -->
          <div v-if="item.type === 'image'">
            <input
              type="file"
              :accept="item.accept"
              @change="updateValue(item.name, $event)"
            />
            <img v-if="item.preview" :src="item.preview" :class="s.image_preview" />
          </div>
        </li>
      </ul>
    </form>
  </div>
</template>

<script>
import DateSelector from '@/components/parts/DateSelector.vue';

export default {
  name: 'form',
  props: {
    items: {
      type: Array,
    },
  },
  components: {
    DateSelector,
  },
  data() {
    return {
      formItems: this.items,
      confirmEmail: '',
    };
  },
  created() {
    this.$emit('changeSubmitFlag', this.readySubmit);
  },
  computed: {
    readySubmit() {
      const isRequired = this.formItems.every((item) => !item.required || (item.required && item.value));
      const isConfirm = this.formItems.every((item) => !item.confirm || (item.confirm && item.value === this.confirmEmail));
      const emailInvalid = this.formItems.every((item) => item.type !== 'email' || !this.isValid(item.type, item.value));
      return isRequired && isConfirm && emailInvalid;
    },
  },
  watch: {
    items: {
      handler() {
        this.$emit('input', this.formItems);
      },
      deep: true,
    },
    readySubmit() {
      this.$emit('changeSubmitFlag', this.readySubmit);
    },
  },
  methods: {
    isValid(type, value) {
      if (type === 'email') {
        const regex = /^[\w-]+(\.[\w-]+)*@([a-z0-9-]+(\.[a-z0-9-]+)*?\.[a-z]{2,6}|(\d{1,3}\.){3}\d{1,3})(:\d{4})?$/;
        return !regex.test(value);
      }
    },
    updateValue(name, e) {
      const target = this.formItems.find((item) => item.name === name);
      if (target && target.type === 'image') {
        target.value = e.target.files[0];
        if (target.value) {
          const reader = new FileReader();
          reader.onload = (event) => {
            target.preview = event.target.result;
          };
          reader.readAsDataURL(target.value);
        }
      } else {
        target.value = e;
      }
    },
  },
};
</script>

<style lang="scss" module="s">
.required {
  color: red;
  font-size: 10px;
}
.valid {
  color: red;
  font-size: 13px;
}

.label_input {
  max-width: 200px;
}
.type_select {
  max-width: 300px;
}
.suffix {
  white-space: nowrap;
}

.select_wrap {
  position: relative;
  select {
    padding-right: 24px;
  }
  &::after {
    content: '';
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(calc(-50% - 2px)) rotate(45deg);
    width: 6px;
    height: 6px;
    border: 1px solid;
    border-color: transparent var(--label-secondary) var(--label-secondary) transparent ;
  }
}

.checkbox {
  cursor: pointer;
  position: relative;
  padding-left: 24px;
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0, -50%);
    height: 12px;
    width: 12px;
    border: 1px solid var(--border-gray);
  }
  &.checked {
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      transform: translate(0, -80%) rotate(-40deg);
      height: 6px;
      width: 12px;
      border: 2px solid;
      border-color: transparent transparent var(--bs-blue) var(--bs-blue);
    }
  }
}
.image_preview {
  width: 33%;
  height: auto;
  margin-top: 10px;
}

</style>
